import { type AssociationType, associationTypesList } from '@/portal-api.definition';
import { ChevronRight, Email, Passport, Smartphone, UserCard } from '@nosinovacao/fe-icons';
import { ListItem, useI18n } from '@nosinovacao/nosid-mfe-common';
import { type ComponentType } from 'react';
import { type SwitchServicesProps } from '../-model/props';

const iconForOption: Record<AssociationType, ComponentType<{ width: number; height: number }>> = {
  Nif: UserCard,
  Phone: Smartphone,
  Email: Email,
  Passport: Passport,
};

export function SwitchServicesLight({ onSelectAssociationType }: Readonly<SwitchServicesProps>) {
  const { t } = useI18n();
  return (
    <div className="grid gap-4">
      {associationTypesList.map((option) => {
        const Icon = iconForOption[option];
        return (
          <ListItem
            skin="light"
            key={option}
            title={t(`Services.AddServices.AssociationType.${option}`)}
            leadingIcon={<Icon width={24} height={24} />}
            onClick={() => onSelectAssociationType(option)}
            trailingIcon={<ChevronRight width={24} height={24} />}
            data-tid={`button-${option.toLowerCase()}`}
          />
        );
      })}
    </div>
  );
}
